import { Link } from "react-router-dom";
import { ArrowRight, Plus } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import PageHero from "../components/PageHero";
import CtaBand from "../components/CtaBand";
import DeliveryChain from "../components/DeliveryChain";
import BrandMark from "../components/BrandMark";
import { Reveal, Eyebrow, SectionHeading } from "../components/Reveal";

const HERO_IMG = "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxkYXRhJTIwY2VudGVyJTIwc2VydmVyJTIwcmFjayUyMGRhcmslMjBjeWJlcnNlY3VyaXR5JTIwaGlnaCUyMHRlY2glMjBBSSUyMHNlcnZlcnxlbnwwfHx8fDE3OTA2MDkxNDV8MA&ixlib=rb-4.1.0&q=85";

export default function Partners() {
  const { t } = useLang();
  const p = t.partners;

  return (
    <>
      <PageHero
        testid="partners-hero"
        eyebrow={p.eyebrow}
        titleLines={p.title}
        paragraphs={[p.p1, p.p2]}
        image={HERO_IMG}
      />

      <section className="py-20 lg:py-28" data-testid="partners-cards">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 space-y-8">
          {p.cards.map((c, i) => (
            <Reveal key={c.name} delay={0.05}>
              <div
                className="glass rounded-lg p-8 lg:p-12 relative overflow-hidden hover:border-sovereign/40 transition-colors duration-500"
                data-testid={`partner-card-${i}`}
              >
                <div className="scanlines absolute inset-0 pointer-events-none" aria-hidden="true" />
                <div className="grid lg:grid-cols-[1fr_1.4fr] gap-10 items-start">
                  <div>
                    <BrandMark name={c.name} className="!text-4xl sm:!text-5xl" />
                    <p className="mt-6 text-slate-300 max-w-md">{c.tagline}</p>
                    <Link
                      to={c.link}
                      data-testid={`partner-card-link-${i}`}
                      className="mt-8 inline-flex items-center gap-3 bg-sovereign text-obsidian font-semibold px-6 py-3 text-xs tracking-[0.15em] uppercase hover:shadow-[0_0_30px_rgba(0,240,255,0.35)] transition-shadow duration-300"
                    >
                      {c.linkText}
                      <ArrowRight className="w-4 h-4" aria-hidden="true" />
                    </Link>
                  </div>
                  <ul className="grid sm:grid-cols-2 gap-3">
                    {c.items.map((item, j) => (
                      <li
                        key={j}
                        className="flex items-center gap-3 border border-sovereign/10 bg-obsidian/50 px-4 py-3.5"
                        data-testid={`partner-${i}-item-${j}`}
                      >
                        <Plus className="w-3.5 h-3.5 text-sovereign shrink-0" aria-hidden="true" />
                        <span className="font-mono text-[11px] tracking-[0.15em] uppercase text-slate-200">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="py-24 lg:py-32 border-t border-sovereign/10" data-testid="partners-chain-section">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <SectionHeading eyebrow={p.chainEyebrow} title={p.chainTitle} />
          <div className="mt-12 glass rounded-lg p-8 lg:p-12">
            <DeliveryChain chain={p.chain} />
          </div>
        </div>
      </section>

      <CtaBand title={t.home.cta.title} text={t.home.cta.text} />
    </>
  );
}
